module.exports = __webpack_public_path__ + "static/media/appstore_nl.c5a46154.svg";